import { AuthStateType } from "../../UserReducer"

export default function fakeAuthReducer (initialState: AuthStateType, action: any) {
    return {
        ...initialState
    }
}